import { BarChart3, Landmark, PiggyBank, ShieldCheck } from 'lucide-react';

export const SUGGESTED_PROMPTS = [
    { icon: PiggyBank, label: 'Compounding', prompt: 'How does compound interest help build wealth over time?' },
    { icon: BarChart3, label: 'ETFs vs. Stocks', prompt: 'What is the difference between an ETF and an individual stock?' },
    { icon: Landmark, label: 'Yield Curve', prompt: 'What does an inverted yield curve signal about the economy?' },
    { icon: ShieldCheck, label: 'Diversification', prompt: 'Why is diversification important in a portfolio?' },
];

interface SuggestedPromptsProps {
    disabled: boolean;
    onPick: (prompt: string) => void;
}

export const SuggestedPrompts = ({ disabled, onPick }: SuggestedPromptsProps) => (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {SUGGESTED_PROMPTS.map(({ icon: Icon, label, prompt }) => (
            <button
                key={label}
                type="button"
                disabled={disabled}
                onClick={() => onPick(prompt)}
                className="group flex items-start gap-3 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-3 text-left shadow-sm transition-all hover:border-emerald-400 hover:shadow-md disabled:opacity-50 disabled:hover:border-slate-200"
            >
                <div className="rounded-lg bg-emerald-50 dark:bg-emerald-900/20 p-2 text-emerald-600 dark:text-emerald-400">
                    <Icon className="h-4 w-4" />
                </div>
                <div className="min-w-0">
                    <div className="text-[10px] font-bold uppercase tracking-widest text-slate-500">{label}</div>
                    <div className="text-xs text-slate-700 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-white">
                        {prompt}
                    </div>
                </div>
            </button>
        ))}
    </div>
);
